import React, { useEffect, useState} from 'react'
import { IVuParams } from '../../Redux/VisualUnits/visualUnitStateSlice'
import { T_VuParamsActionState } from './DashboardVuParams'
import FilterValueDropdown from '../VisualUnitParams/HLFilterValueDropdown'
import { FoundationsConstants } from '../../FoundationsConstants'
import HLSearchlist from '../VisualUnitParams/HLSearchlist'
import HLList from '../VisualUnitParams/HLList'
import GenericFilters from '../VisualUnitParams/GenericFilters'
import HLDimensionBinList from '../VisualUnitParams/HLDimensionBinList'
import NoFilter from '../VisualUnitParams/HLNoFilter'
import HLAggricateList from './HLAggricateList'
import { IBusinessParamsOptions } from './VisualUnitParamsDialog'
import { IAggricateObj, IBusinessParameter, ISingleValueReportList } from '../../Redux/VisualUnits/vuParamSlice'
import MetadataQuickSearch from '../VisualUnitParams/MetadataQuickSearch'
interface IVURegion {
    paramsAction: T_VuParamsActionState,
    currentHLDataType: string,
    setBusinessParamChecked: Function,
    showBusinessParameter: boolean,
    businessParamChecked:  0 | 1,
    isAggrigateLoading: boolean | undefined,
    selectFilterValueOption: any,
    selectedLeftItem: any,
    displayType: string,
    singleValueReportList: ISingleValueReportList[],
    businessParameterList: IBusinessParameter[],
    aggricateListResp: IAggricateObj[],
    selectedParameters: any,
    //from useHook
    aggrSelection: any,
    filterSelection: any,
    
    metadataSearchResult: any,
    filterableMetaDataId: any,
    binMetadataData: {binList: any[]},
    selectedDurations: any,
    formatGenericFilterValues: any,
    bpDropDownOptions: IBusinessParamsOptions[],
    showQuickSearch: boolean,
    fetchingResp: boolean
}

const VuParamsFilterRegion = (props: IVURegion) => {
    //isaggri
    const {
        paramsAction,
        currentHLDataType,
        setBusinessParamChecked,
        showBusinessParameter,
        businessParamChecked,
        isAggrigateLoading, //single loading which handles loader
        selectFilterValueOption,
        selectedLeftItem,
        displayType,
        singleValueReportList,
        businessParameterList,
        aggricateListResp,
        selectedParameters,
        //from useHook
        aggrSelection, //measure
        filterSelection, //For filter & bins dimensions

        metadataSearchResult,
        filterableMetaDataId,
        binMetadataData,
        //below for Generic Filter selection (durations, HL number etc)
        selectedDurations,
        formatGenericFilterValues,
        bpDropDownOptions,
        showQuickSearch
    } = props

    //Maintain Use hook state inside Parent component only

    const [selectAllHLLIst, setSelectAllHLList] = useState<{ isUpdate: null | number, selectAll: boolean | null }>({ isUpdate: null, selectAll: null })
    const [isSearched, setIsSearched] = useState<boolean>(false)
    const [filteredArray, setFilteredArray] = useState<any[]>([])

    useEffect(() => {
        if (!isAggrigateLoading) {
            setIsSearched(false)
            setSelectAllHLList({ isUpdate: null, selectAll: false })
        }
    }, [isAggrigateLoading])

    const handleSelectClear = (isSelectAll: boolean) =>{
        setSelectAllHLList({
            isUpdate : Date.now(),
            selectAll: isSelectAll
        })
    }

    const returnAggricateArray = () =>{
        let array: any[] = []
        switch (paramsAction) {
            case 'addmeasure':
            case 'updateMeasure':
                if(displayType ===FoundationsConstants.FetchVuParamsDisplayType.BusinessParameterList){
                    array = props.businessParameterList
                }else if(displayType ===FoundationsConstants.FetchVuParamsDisplayType.SingleValueReportList){
                    array = props.singleValueReportList
                }else if(displayType ===FoundationsConstants.FetchVuParamsDisplayType.AggricateList){
                    array = props.aggricateListResp
                }else{ //Handle case for Measure set
                   array= []
                }
            break;
            case "addfilter":
            case "updateFilter":
                if(displayType ===FoundationsConstants.FetchVuParamsDisplayType.HLLIST){
                    array = props.metadataSearchResult
                }
            break;
            case "addrow":
            case "updateRow":
            case "addcolumn":
            case "updateColumn":
                if(displayType ===FoundationsConstants.FetchVuParamsDisplayType.BINLIST){
                    array = binMetadataData.binList
                }
            break;
            
        }
        return array
    }

  return (
      <td className="vu-popup-right-col">
          <div className="vu-popup-element-wrapper">
              <div
                  id="vu_popup_element_header"
                  className="float-left vu-popup-element-header hide"
              ></div>
              <div
                  id="vu_popup_element_subheader"
                  className="float-left vu-popup-element-subheader"
              >
                  <div className="float-left fieldradio">
                      <span className="mb-1">
                          {' '}
                          {paramsAction === 'addmeasure' ||
                              paramsAction === 'updateMeasure'
                              ? 'Aggregates'
                              : paramsAction === 'addfilter' ||
                                  paramsAction === 'updateFilter'
                                  ? 'Filter Values'
                                  : (paramsAction === 'addcolumn' ||
                                      paramsAction === 'updateColumn' ||
                                      paramsAction === 'addrow' ||
                                      paramsAction === 'updateRow') &&
                                  'Bins'}
                      </span>
                      <br />
                      {
                          (paramsAction === "addfilter" || paramsAction === "updateFilter") &&
                          <span onClick={() => {setBusinessParamChecked(0)}}> 
                              <input
                                  type="radio"
                                  id="filterValuesRadio"
                                  name="filteroptionsradio"
                                  checked={businessParamChecked === 0}
                                  readOnly
                              />
                              <label className="ms-2">&nbsp;Enter Value</label>
                              &nbsp;
                          </span>
                      }

                      {
                          showBusinessParameter && (paramsAction === "addfilter" || paramsAction === "updateFilter" ) &&
                          <span onClick={() => setBusinessParamChecked(1)}>
                              <input
                                  type="radio"
                                  id="filterValuesRadio"
                                  name="filteroptionsradio"
                                  checked={businessParamChecked === 1}
                                  readOnly
                              />&nbsp;
                              <label className="ms-2" id="BPRadio_label">
                                  Business Parameter
                              </label>
                          </span>
                      }
                  </div>
                  
                  {displayType === "HLLIST" && (
                      <FilterValueDropdown
                          selectFilterValueOptionFn={selectFilterValueOption}
                          selectedDropdownOptn={selectedParameters.data?.filterOptions}
                      />
                  )}
              </div>
              {isAggrigateLoading && (
                  <span id="vu_popup_loading" className="ajax-loading-box">
                      <span className="ajax-loading-image">Loading...</span>
                  </span>
              )}
              <div className="clear-both"></div>
          </div>

          <MetadataQuickSearch filterableMetaDataId={filterableMetaDataId} showQuickSearch={showQuickSearch} opsArray={returnAggricateArray()} setIsSearched={setIsSearched} setFilteredArray={setFilteredArray} />

          <div
              id="vu_popup_element_props"
              className={
                displayType === FoundationsConstants.FetchVuParamsDisplayType.HL_SEARCHLIST ?
                "vu-popup-searchlist-props" :
                "vu-popup-element-props vu-popup-element-props-default"}
          >
              {Object.keys(selectedLeftItem).length === 0 && (
                  <NoFilter
                      isAggrigateLoading={isAggrigateLoading}
                      action={paramsAction}
                  />
              )}
              {
                  (displayType === FoundationsConstants.FetchVuParamsDisplayType.AggricateList || FoundationsConstants.FetchVuParamsDisplayType.BusinessParameterList || FoundationsConstants.FetchVuParamsDisplayType.SingleValueReportList) &&
                  <HLAggricateList
                  isFetchingResp={props.fetchingResp}
                      data={{ displayType, businessParameterList: isSearched ? filteredArray : businessParameterList, aggricateListResp: isSearched ? filteredArray : aggricateListResp, singleValueReportList: isSearched ? filteredArray : singleValueReportList }}
                      {...aggrSelection}
                  />
              }

              {displayType === FoundationsConstants.FetchVuParamsDisplayType.HL_SEARCHLIST && (
                  <HLSearchlist
                  isFetchingResp={props.fetchingResp}
                  selectFilterValueOptionFn={selectFilterValueOption}
                    data={{ displayType, 
                        metadata: metadataSearchResult, 
                        selectedParameters, 
                        filterableMetaDataId }}
                    {...filterSelection}
                  />
              )}
              {displayType === FoundationsConstants.FetchVuParamsDisplayType.HLLIST && ( //selectCheckBoxValuesFn
                  <>
                      <HLList
                        isFetchingResp={props.fetchingResp}
                          selectState={selectAllHLLIst}
                          data={{
                              displayType,
                              metadata: isSearched ? filteredArray: metadataSearchResult,
                              selectedParameters,
                              filterableMetaDataId
                          }}
                          {...filterSelection}
                      />
                  </>
              )}

              {displayType === FoundationsConstants.FetchVuParamsDisplayType.GENERIC_FILTERS && (
                  <GenericFilters
                      selectedParameters={{ ...selectedParameters, displayText: selectedDurations }}
                      responseFilterValues={metadataSearchResult}
                      filterableId={filterableMetaDataId}
                      bpdropDownOptions={bpDropDownOptions}
                      currentHLDataType={currentHLDataType}
                      isBusinessParameterReplace={businessParamChecked}
                      Addmethod={formatGenericFilterValues}
                  />
              )}

              {displayType === FoundationsConstants.FetchVuParamsDisplayType.BINLIST && (
                  <HLDimensionBinList
                  {...aggrSelection}
                  isFetchingResp= {props.fetchingResp}
                      binList={isSearched ? filteredArray : binMetadataData.binList}
                  />
              )}
          </div>
          {/* Moved already to NoFilter component */}
          {(displayType === FoundationsConstants.FetchVuParamsDisplayType.HLLIST) && (
              <div
                  id="vu_popup_filter_options_1"
                  className="vu-popup-filter-options-1"
              >
                  <span id="vu_popup_filtervalue_list_count">{metadataSearchResult.length}</span> items •
                  <a
                      href="javascript:void(0);"
                      onClick={() => handleSelectClear(true)}
                  >
                      select all
                  </a>{' '}
                  •
                  <a
                      href="javascript:void(0);"
                      onClick={() => handleSelectClear(false)}
                  >
                      clear all
                  </a>
              </div>
          )}
          {
              displayType === FoundationsConstants.FetchVuParamsDisplayType.HL_SEARCHLIST &&
              <div
                  id='vu_popup_searchlist_sel_list_filter_options'
                  className='vu-popup-filter-options-1'>
                  <a
                      href="javascript:void(0);"
                      onClick={() => filterSelection.clearSelection()}
                  >
                      clear all
                  </a>
              </div>
          }
      </td>
  )
}

export default VuParamsFilterRegion